var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('app-header'),_c('app-main',{staticClass:"app-main"}),(this.$route.path != '/home')?_c('app-footer'):_vm._e(),_c('div',{staticClass:"serve",on:{"click":_vm.windowClick}},[_c('img',{attrs:{"src":require("../assets/img/service.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }